import React from "react";

import FilterCompany, { FilterOption } from "./FilterCompany";
import SearchCompany from "./SearchCompany";
import { SearchFilterCompanyContainer } from "./styles";

interface Props {
  searchInput: string;
  onChangeInput: (value: string) => void;
  filterOptions: FilterOption[];
  setFilterOptions: (values: FilterOption[]) => void;
}

const SearchFilterCompany = ({
  setFilterOptions,
  onChangeInput,
  filterOptions,
  searchInput,
}: Props) => {
  return (
    <SearchFilterCompanyContainer>
      <SearchCompany onChangeInput={onChangeInput} searchInputValue={searchInput} />

      <FilterCompany filterOptions={filterOptions} setFilterOptions={setFilterOptions} />
    </SearchFilterCompanyContainer>
  );
};

export default SearchFilterCompany;
